import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useContent } from "@/content/ContentContext";

const links = [
  { label: "Über mich", href: "#ueber-mich", id: "nav-about-link" },
  { label: "Leistungen", href: "#leistungen", id: "nav-services-link" },
  { label: "Vorher / Nachher", href: "#vorher-nachher", id: "nav-before-after-link" },
];

export const Nav = () => {
  const content = useContent();
  const { whatsapp, whatsapp_text } = content.contact;
  const whatsappUrl = `https://wa.me/${whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(whatsapp_text)}`;

  return (
  <motion.header
    data-testid="main-nav"
    initial={{ y: -72 }}
    animate={{ y: 0 }}
    transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-foreground/10 bg-background/80 backdrop-blur-xl"
  >
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:px-10">
      <a href="#start" data-testid="nav-logo" aria-label="Rundum – zur Startseite">
        <img
          src="/rundum-logo.png"
          alt="Rundum Logo"
          className="h-9 w-auto object-contain object-left"
        />
      </a>
      <nav className="hidden items-center gap-8 md:flex">
        {links.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.id}
            className="group relative font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-300 hover:text-foreground"
          >
            {l.label}
            <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-[width] duration-300 group-hover:w-full" />
          </a>
        ))}
        <a
          href="/sanierungs-assistent.html"
          data-testid="nav-assistent-link"
          className="group relative font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-300 hover:text-foreground"
        >
          Assistent
          <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-[width] duration-300 group-hover:w-full" />
        </a>
        <a
          href="/portal"
          data-testid="nav-portal-link"
          className="group relative font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-300 hover:text-foreground"
        >
          Kundenportal
          <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-[width] duration-300 group-hover:w-full" />
        </a>
      </nav>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Per WhatsApp Kontakt aufnehmen"
        data-testid="nav-call-button"
        className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-foreground text-background transition-colors duration-300 hover:bg-primary hover:text-primary-foreground"
      >
        <MessageCircle className="h-4 w-4" />
      </a>
    </div>
  </motion.header>
  );
};
